import * as React from 'react';
import PropTypes from 'prop-types';
import { TmsEventUsapApplicationStatusTypes, TmsEventUsapVerificationTypes } from '../../utils/eventConstants';

const USAPLogo = ({ usapApplicationStatusId, usapVerificationTypeId, 'data-testid': dataTestId }) => {
    if (usapApplicationStatusId === TmsEventUsapApplicationStatusTypes.PENDING) {
        return <img width={76} height={50} className="" src="/img/icons/USAPickleball_SanctionPendingLogo_Print.jpg" data-testid={dataTestId || undefined} />;
    }
    if (usapApplicationStatusId === TmsEventUsapApplicationStatusTypes.DECLINED) {
        return null;
    }
    if (usapApplicationStatusId === TmsEventUsapApplicationStatusTypes.APPROVED && usapVerificationTypeId === TmsEventUsapVerificationTypes.MEDAL_MATCH_PLUS) {
        return <img width={76} height={50} className="" src="/img/icons/USAPickleball_MMPSanctionedEventLogo_Print.jpg" data-testid={dataTestId || undefined} />;
    }
    if (usapApplicationStatusId === TmsEventUsapApplicationStatusTypes.APPROVED && usapVerificationTypeId === TmsEventUsapVerificationTypes.STANDARD) {
        return <img width={76} height={50} className="" src="/img/icons/USAPickleball_SanctionedEventLogo_Print.jpg" data-testid={dataTestId || undefined} />;
    }
    if (usapApplicationStatusId === TmsEventUsapApplicationStatusTypes.APPROVED && usapVerificationTypeId === TmsEventUsapVerificationTypes.NO_REFEREE) {
        return <img width={76} height={50} className="" src="/img/icons/USAPickleball_NoRefSanctionedEventLogo.png" data-testid={dataTestId || undefined} />;
    }
    return null;
};

USAPLogo.propTypes = {
    usapApplicationStatusId: PropTypes.number,
    usapVerificationTypeId: PropTypes.number,
    'data-testid': PropTypes.string,
};

USAPLogo.defaultProps = {
    usapApplicationStatusId: null,
    usapVerificationTypeId: null,
    'data-testid': null,
};

export default USAPLogo;
